export default [
  // India
  { code: 'AN', name: 'Andaman and Nicobar Islands', country: 'India' },
  { code: 'AP', name: 'Andhra Pradesh', country: 'India' },
  { code: 'AR', name: 'Arunachal Pradesh', country: 'India' },
  { code: 'AS', name: 'Assam', country: 'India' },
  { code: 'BR', name: 'Bihar', country: 'India' },
  { code: 'CH', name: 'Chandigarh', country: 'India' },
  { code: 'CT', name: 'Chhattisgarh', country: 'India' },
  { code: 'DN', name: 'Dadra and Nagar Haveli and Daman and Diu', country: 'India' },
  { code: 'DL', name: 'Delhi', country: 'India' },
  { code: 'GA', name: 'Goa', country: 'India' },
  { code: 'GJ', name: 'Gujarat', country: 'India' },
  { code: 'HR', name: 'Haryana', country: 'India' },
  { code: 'HP', name: 'Himachal Pradesh', country: 'India' },
  { code: 'JK', name: 'Jammu and Kashmir', country: 'India' },
  { code: 'JH', name: 'Jharkhand', country: 'India' },
  { code: 'KA', name: 'Karnataka', country: 'India' },
  { code: 'KL', name: 'Kerala', country: 'India' },
  { code: 'LD', name: 'Lakshadweep', country: 'India' },
  { code: 'MP', name: 'Madhya Pradesh', country: 'India' },
  { code: 'MH', name: 'Maharashtra', country: 'India' },
  { code: 'MN', name: 'Manipur', country: 'India' },
  { code: 'ML', name: 'Meghalaya', country: 'India' },
  { code: 'MZ', name: 'Mizoram', country: 'India' },
  { code: 'NL', name: 'Nagaland', country: 'India' },
  { code: 'OR', name: 'Odisha', country: 'India' },
  { code: 'PY', name: 'Puducherry', country: 'India' },
  { code: 'PB', name: 'Punjab', country: 'India' },
  { code: 'RJ', name: 'Rajasthan', country: 'India' },
  { code: 'SK', name: 'Sikkim', country: 'India' },
  { code: 'TN', name: 'Tamil Nadu', country: 'India' },
  { code: 'TG', name: 'Telangana', country: 'India' },
  { code: 'TR', name: 'Tripura', country: 'India' },
  { code: 'UP', name: 'Uttar Pradesh', country: 'India' },
  { code: 'UT', name: 'Uttarakhand', country: 'India' },
  { code: 'WB', name: 'West Bengal', country: 'India' },

    // United States
  { code: 'NY', name: 'New York', country: 'United States' },
  { code: 'CA', name: 'California', country: 'United States' },
  { code: 'TX', name: 'Texas', country: 'United States' },
  { code: 'FL', name: 'Florida', country: 'United States' },
  { code: 'IL', name: 'Illinois', country: 'United States' },

    // Canada
  { code: 'ON', name: 'Ontario', country: 'Canada' },
  { code: 'QC', name: 'Quebec', country: 'Canada' },
  { code: 'BC', name: 'British Columbia', country: 'Canada' },
  { code: 'AB', name: 'Alberta', country: 'Canada' },
  { code: 'MB', name: 'Manitoba', country: 'Canada' },

  // Australia
  { code: 'NSW', name: 'New South Wales', country: 'Australia' },
  { code: 'VIC', name: 'Victoria', country: 'Australia' },
  { code: 'QLD', name: 'Queensland', country: 'Australia' },
  { code: 'WA', name: 'Western Australia', country: 'Australia' },
  { code: 'SA', name: 'South Australia', country: 'Australia' },

  // United Kingdom
  { code: 'ENG', name: 'England', country: 'United Kingdom' },
  { code: 'SCT', name: 'Scotland', country: 'United Kingdom' },
  { code: 'WLS', name: 'Wales', country: 'United Kingdom' },
  { code: 'NIR', name: 'Northern Ireland', country: 'United Kingdom' },
];